import { render, staticRenderFns } from "./LimitPage.vue?vue&type=template&id=7b0ab852&scoped=true&"
import script from "./LimitPage.vue?vue&type=script&lang=js&"
export * from "./LimitPage.vue?vue&type=script&lang=js&"
import style0 from "./LimitPage.vue?vue&type=style&index=0&id=7b0ab852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ab852",
  null
  
)

export default component.exports